import React from "react";
import "../styles/Control-Material.scss";
import "../styles/Control.scss";
import Dropdown from "./Dropdown";

const cats = require("../data/categories.json");

type ControlConfig = {
  selectedOptions: Record<string, [string, string[]]>;
  setOption(cat: string, newValue: string): void;
  activeTab: string;
};

const Control: React.FC<ControlConfig> = ({
  selectedOptions,
  setOption,
  activeTab,
}) => {
  return (
    <div id="control-container" className={"active-" + activeTab}>
      {Object.keys(selectedOptions).map((cat, i) => (
        <Dropdown
          isDisabled={
            (activeTab === "map" && cat === "Geography") ||
            (activeTab === "table" && cat === "Variable")
          }
          name={cat}
          data={selectedOptions[cat][1]}
          key={i}
          selectedOption={selectedOptions[cat][0]}
          setOption={setOption}
          info={cat === "Demographics"}
        ></Dropdown>
      ))}
    </div>
  );
};

export default Control;
